import { render, staticRenderFns } from "./rolePermissions.vue?vue&type=template&id=ef34fb3c&scoped=true"
import script from "./rolePermissions.vue?vue&type=script&lang=js"
export * from "./rolePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef34fb3c",
  null
  
)

export default component.exports